import { IWindow } from '@phdsoft/window';
import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';

export interface ModalOptions {
  title: string;
  confirmButtonText: string;
  cancelButtonText: string;
  question: string;
  item?: string;
  result?: boolean;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'phdsoft-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
})
export class ModalConfirmComponent {

  optionsWindow: IWindow = {
    Position: 'center',
    PositionMini: '',
    VisibleMini: false,
    Header: {
      Icon: 'info',
      VisibleTitle: false,
      Title: 'Modal Confirm',
      Visible: false
    },
    Footer: {
      Visible: true,
      ShowCancel: false
    }
  };

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public options: ModalOptions
  ) {

  }

  confirm(): void {
    this.options.result = true;
    this.dialogRef.close(this.options);
  }

  cancel(): void {
    this.options.result = false;
    this.dialogRef.close(this.options);
  }

}
